var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page d-flex flex-column justify-space-between"},[_c('div',[_c('button',{staticClass:"btn-standard mt-4",attrs:{"type":"button"},on:{"click":_vm.gotoFrontPage}},[_vm._v("\n      "+_vm._s(_vm.$t('go.to.dn'))+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }